
import { Component, Mixins } from "vue-property-decorator";
import { Vector, Rectangle } from "../../../../../../../base/domain/drawing";
import { VectorCoordinateEditableMixin } from "../mixins";
import { default as ObjectDrawerBase } from "./ObjectDrawerBase.vue";

@Component
export default class VectorCoordinatableObjectDrawerBase extends Mixins(ObjectDrawerBase, VectorCoordinateEditableMixin) {
  get absoluteGeometryStyleProperties() {
    return {
      left: this.offsetRectangleCoordinate.topLeft.x + "px",
      top: this.offsetRectangleCoordinate.topLeft.y + "px",
      width: this.offsetRectangleCoordinate.size.width + "px",
      height: this.offsetRectangleCoordinate.size.height + "px",
    };
  }

  get offsetRectangleCoordinate(): Rectangle {
    const offset = Rectangle.from(this.offsetVectorCoordinate);
    return !this.isSelected
      ? offset
      : new Rectangle(
        offset.topLeft.add(this.offsets.relocatingOffset),
        offset.size);
  }

  get offsetVectorCoordinate(): Vector {
    return (this.offsets.source && this.offsets.source.isReferedSameSource(this.editingSource) && this.offsets.transformingVector)
      ? this.offsets.transformingVector
      : this.vectorCoordinate;    
  }
}
